export default __webpack_public_path__ + "static/media/clearp04.b35f515c.png";